<div>
  <h4>{{ result?.registryForm?.formFull ?? 'Change Text' }}</h4>
  <ul>
    @for (change of changeText; track change) {
      <li>{{ change }}</li>
    }
  </ul>
</div>
<div class="flex-container">
  <div class="flex-item">
    <div class="flex-container">
      <span class="flex-item">{{ 'amendmentResults.externalNumber' | transloco }}</span>
      <span class="flex-item-2">{{ result?.externalOrderNumber?.number }}</span>
    </div>
    <div class="flex-container">
      <span class="flex-item">{{ 'amendmentResults.dateReceived' | transloco }}</span>
      <span class="flex-item-2">{{ $safeNavigationMigration(result?.externalOrderNumber?.dateReceived) |
      localizedDate:'yyyy-MM-dd HH:mm' }}</span>
    </div>
  </div>
  <div class="flex-item">
    <lib-lien-results [results]="result"></lib-lien-results>
  </div>
</div>